import { getRecordKeys } from "@atlassiansox/bxp-shared-utils";

export const PRODUCT_NAMES = {
    "jira.ondemand": "Jira",
    "jira-core.ondemand": "Jira Work Management",
    "greenhopper.jira.ondemand": "Jira Agile",
    "jira-software.ondemand": "Jira",
    "com.atlassian.servicedesk.ondemand": "Jira Service Desk",
    "jira-servicedesk.ondemand": "Jira Service Management",
    "jira-incident-manager.ondemand": "Jira Ops",
    "com.radiantminds.roadmaps-jira.ondemand": "Jira Portfolio",
    "bonfire.jira.ondemand": "Jira Capture",
    "confluence.ondemand": "Confluence",
    "com.atlassian.confluence.plugins.confluence-questions.ondemand":
        "Confluence Questions",
    "team.calendars.confluence.ondemand": "Confluence Team Calendars"
} as const;

export type ProductKeyType = keyof typeof PRODUCT_NAMES;

export const PRODUCT_KEYS = getRecordKeys(PRODUCT_NAMES);

export function isProductKey(value: string): value is ProductKeyType {
    return PRODUCT_KEYS.some((productKey) => value === productKey);
}

export enum ProductKey {
    JIRA_SOFTWARE = "jira-software.ondemand",
    BITBUCKET = "com.atlassian.bitbucket",
    CONFLUENCE = "confluence.ondemand",
    OPSGENIE = "opsgenie",
    JIRA_SERVICE_DESK = "jira-servicedesk.ondemand",
    JIRA_SERVICE_MANAGEMENT = "jira-servicedesk.ondemand",
    JIRA_CORE = "jira-core.ondemand",
    JIRA_WORK_MANAGEMENT = "jira-core.ondemand",
    ACCESS = "com.atlassian.identity-manager",
    STATUSPAGE = "statuspage",
    CONFLUENCE_PLUGIN_QUESTIONS = "com.atlassian.confluence.plugins.confluence-questions.ondemand",
    CONFLUENCE_TEAM_CALENDARS = "team.calendars.confluence.ondemand",
    JIRA_ROADMAPS = "com.radiantminds.roadmaps-jira.ondemand",
    JIRA_BONFIRE = "bonfire.jira.ondemand",
    JIRA_REFAPP = "refapp",
    TEAM_CENTRAL = "townsquare",
    JIRA_PRODUCT_DISCOVERY = "jira-product-discovery",
    COMPASS = "compass",
    ATLAS = "townsquare",
    FABRIC = "atlassian-whiteboard",
    BEACON = "beacon"
}
